import {Company} from '../store/MultiCompanies';

export function deserialize(companies: Company[]) {
    const outputJson = {tables: []};
    const table = {tableName: 'MultiCompanies', rows: []};
    companies.forEach(company => {
        const row = {data: company.value};
        table.rows.push(row);
        outputJson.tables.push(table);
    });
    return outputJson;
}
